export default "__VITE_ASSET__DPgJ3Hf6__"